import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL, Building } from '@edl-development/edl-common';
import { BuildingDTO } from '../model/buildings/building-dto.model';
import { BuildingAdminDTO } from '../model/buildings/building-management.model';

@Injectable()
export class BuildingApi extends BaseApi {

  constructor(
    @Inject(BASE_URL) private baseUri: string,
    private http: HttpClient
  ) {
    super();
  }

  getPortalBuildings() {
    return this.http.get<Building[]>(this.baseUri + '/building/get', {});
  }

  getBuildingsForAdmin() {
    return this.http.get<BuildingAdminDTO[]>(
      this.baseUri + '/building/district-buildings',
      {}
    );
  }

  getAssignedBuildings(userId: string) {
    return this.http.get<Building[]>(
      this.baseUri + '/building/assigned/' + userId,
      {}
    );
  }

  getBuildingDetails(buildingId: number) {
    return this.http.get<Building[]>(
      this.baseUri + '/building/details/' + buildingId,
      {}
    );
  }

  saveBuilding(building: BuildingAdminDTO) {
    return this.http.post(
      this.baseUri + '/building/save',
      building
    );
  }

  deleteBuilding(building: BuildingAdminDTO) {
    return this.http.delete(
      this.baseUri + '/building/delete/'+ building.buildingID
    );
  }

  preCheckDeleteBuilding(building: BuildingAdminDTO) {
    return this.http.get(
      this.baseUri + '/building/delete/precheck/'+ building.buildingID,
    );
  }
}
